import 'whatwg-fetch';
import { browserHistory } from 'react-router';
import { ssoLogin, ssoLogout, logoutRedirectUri, ssoCheckSession } from '../api';
import { LANGUAGES, ERROR_MESSAGE } from '../constants';
import { setErrorSecurity } from './errorSecurity';
import { trans } from '../localization/language';
import _ from 'lodash';

/*
	Action generators
*/

function initDataAction(data) {
	return {
		type: 'INIT',
		data: data
	}
}

function updateUserSuspiciousAction(data) {
	return {
		type: 'UPDATE_USER_SUSPICIOUS',
		data: data
	}
}

function logsAction(data) {
	return {
		type: 'FETCH_LOGS',
		data: data
	}
}

export function updateEmailAction(data) {
	return {
		type: 'UPDATE_EMAIL',
		data: data
	}
}

export function changeLanguageAction(data) {
	return {
		type: 'CHANGE_LANGUAGE',
		data: data
	}
}

/*
	Async functions
*/
export function initData() {
	var initUrl = '/api/account/init';
	return dispatch => {
		fetch(initUrl, {credentials: 'same-origin'})
		.then(response => response.json())
		.then(data => {
			if (data.country) return data;
			return fetch('/api/get_ip', { method: 'POST' })
				.then((response) => response.json())
				.then((data) => data.country)
				.then((country) => (country ? { ...data, country } : data))
				.catch(() => data);
		})
		.then(data => handleInitData(dispatch, data))
	}
}

export function logout() {
	return dispatch => {
		fetch('/api/account/logout', { credentials: 'same-origin'})
			.then(response => response.json())
			.then(data => handleLogout(dispatch, data))
	}
}


export function fetchMoreLogs(uid, last_login_ts, last_im_ts) {
	var api_params = {};
	if(last_login_ts) api_params['last_login_ts'] = last_login_ts;
	if(last_im_ts) api_params['last_im_ts'] = last_im_ts;
	return dispatch => {
		fetch('api/account/login_logs/get',{
			credentials: 'same-origin',
			method: 'POST',
			headers: {
				'Content-Type':'application/json'
			},
			body: JSON.stringify(api_params)
		})
			.then(response => response.json())
			.then(data => handleLogs(dispatch, data))
	}
}


/*
 Helper functions
 */
export function invokeApi(apiName, params, successFn){
	return dispatch => {
		fetch(apiName, params)
			.then(response => response.json())
			.then(data => handleData(dispatch, data, successFn))
			.catch(error => {
				let message = _.join([typeof(error), error.toString()]);
				console.log(`invoke api error ${message}`);
				dispatch(setErrorSecurity(trans('Error'), message));
				browserHistory.push('/security/error_security');
			})
	}

}

export const handleDataDomeResponse = (resend) => (response) => {
	const isDataDomeCaptchaRequired =
		(response.status === 401 || response.status === 403) &&
		response.headers.has('x-dd-b');
	if (isDataDomeCaptchaRequired) {
		return new Promise((resolve) => {
			const onDDResponseUnload = () => {
				window.removeEventListener(
					'dd_response_unload',
					onDDResponseUnload
				);
				resolve();
			};
			window.addEventListener(
				'dd_response_unload',
				onDDResponseUnload
			);
		}).then(resend);
	}
	return response.json();
};

export function invokeApiDataDome(apiName, params, successFn) {
	return (dispatch) => {
		(function resend() {
			return fetch(apiName, {
				...params,
				headers: {
					...params.headers,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			}).then(handleDataDomeResponse(resend));
		})()
			.then((data) => handleData(dispatch, data, successFn))
			.catch((error) => {
				let message = _.join([typeof error, error.toString()]);
				console.log(`invoke api error ${message}`);
				dispatch(setErrorSecurity(trans('Error'), message));
				browserHistory.push('/security/error_security');
			});
	};
}

export function handleData(dispatch, data, successFn){
	if('error' in data){
		switch (data.error){
			case 'error_suspicious_ip':
				browserHistory.push('/error_login');
				break;
			case 'error_email_need_contact_cs':
				browserHistory.push('/security/email/contact-customer-service');
				break;
			case 'error_session':
				console.log('error_sesion in common.js');
				ssoLogin();
				break;
			default:
				let message = trans(data.error) || trans('error_server_hint');
				console.log(_.join(['default error in common.js', data.error, message]));
				dispatch(setErrorSecurity(trans('Error'), message));
				browserHistory.push('/security/error_security');
				break;
		}
		return;
	}
	return successFn(dispatch, data);
}

export function handleError(data) {
	switch (data.error) {
		case ERROR_MESSAGE.ERROR_SUSPICIOUS_IP:
			browserHistory.push('/error_login');
			break;
		case ERROR_MESSAGE.ERROR_ACTION:
			browserHistory.push('/security/error_action');
			break;
		case ERROR_MESSAGE.ERROR_SERVER:
			browserHistory.push('/security/error_server');
			break;
		case ERROR_MESSAGE.ERROR_RETRY:
			browserHistory.push('/security/error_retry');
			break;
		case ERROR_MESSAGE.ERROR_RATE_LIMIT:
			browserHistory.push('/security/error_retry');
			break;
		case ERROR_MESSAGE.ERROR_EMAIL_NEED_CONTACT_CS:
			browserHistory.push('/security/email/contact-customer-service');
			break;
		case ERROR_MESSAGE.ERROR_SESSION:
			console.log('error_sesion in common.js');
			ssoLogin();
			break;
		default:
			browserHistory.push('/security/error/' + data.error);
			console.log('default error in common.js'+data.error);
			// refresh the app to get correct data
			// window.location = '/';
			break;
	}
}

function handleInitData(dispatch, data) {
	if(!localStorage.getItem('lang')){
		LANGUAGES.forEach(function (language) {
			if (language.country === data.country) {
				dispatch(changeLanguageAction(language));
			}
		});
	}
	if ('error' in data) {
		handleError(data);
		return;
	}
	dispatch(initDataAction(data));
}

function handleLogs(dispatch, data) {
	if ('error' in data) {
		handleError(data);
		return;
	}
	dispatch(logsAction(data));
}

function handleLogout(dispatch, data) {
	if ('error' in data) {
		// session alr expired, no need to logout
		window.location = logoutRedirectUri();
		return;
	}
	ssoLogout(data.session_key, data.uid);
}

export function initWhitelistUser() {
	return dispatch => {
		fetch('/api/account/whitelist_user', {credentials: 'same-origin'})
			.then(response => response.json())
			.then(data => handleInitWhitelistUser(dispatch, data))
	}
}

function handleInitWhitelistUser(dispatch, data) {
	if ('error' in data) {
		handleError(data);
		return;
	}
	dispatch(updateUserSuspiciousAction(data));
}


// WEBPACK FOOTER //
// ./app/actions/common.js